<script setup lang="ts">
import maplibregl from "maplibre-gl";
const emit = defineEmits(['markerClick'])

const props = defineProps<{
  markers: number[],
  options: {
    center: number[],
    zoom: number,
  },
  height: string
}>()

const map = ref(null)

onMounted(() => {
  map.value = new maplibregl.Map({
    container: "map",
    style: {
      "version": 8,
      "sources": {
        "osm": {
          "type": "raster",
          "tiles": ["https://tile.openstreetmap.org/{z}/{x}/{y}.png"],
          "tileSize": 32,
          "attribution": "&copy; OpenStreetMap contributors",
          "maxzoom": 18
        }
      },
      "layers": [
        {
          "id": "osm",
          "type": "raster",
          "source": "osm" // This must match the source key above
        }
      ]
    },
    center: [...props.options?.center].reverse(),
    zoom: props.options?.zoom,
  })

  //map.value.on('load', onMapLoaded)
})

async function onMapLoaded(instance) {
  props.markers.map(marker => {
    addMarker(marker, map.value)
  })
}

function addMarker(marker, map) {

}

function onMapMouseUp(test) {

}
</script>

<template>
  <div id="map" />
</template>

<style lang="scss">
#map {
  position: relative;
  overflow: hidden;
  height: v-bind(height);
  pointer-events: none;

  canvas {
    opacity: 0.75;
  }
}
</style>